<template>
  <v-app>
      <div style="margin-top:120px">
         <v-container>
       <v-layout row wrap>
           <v-flex xs12>
             <div class="res" style="margin-left:50px;margin-right:50px;">
                           <img :src=this.blogDetail.imageSrc width="100%" height="350px">
                         </div>

                         <div class="man" style="margin-left:20px;margin-right:20px;">
                           <img :src=this.blogDetail.imageSrc width="100%" height="300px">
                         </div>
           </v-flex>
           <v-flex xs12>
             <h1 class="res" style="text-align:center;color:#0d47a1;padding:10px">{{blogDetail.title}}</h1>
             <h4 class="man" style="text-align:center;color:#0d47a1;padding:10px">{{blogDetail.title}}</h4>
           </v-flex>
           <v-flex xs12>
             <p style="text-align:center;padding:10px">{{blogDetail.description}}</p>
           </v-flex>
       </v-layout>
       </v-container>
      </div>
    
  </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
      
      blogDetail: null,
    };
  },


  mounted() {
      this.axios
        .get(config.API + `Blogs2/${this.$route.params.id}`, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.blogDetail = res.data;
          this.$Progress.finish();
        })
        .catch(err => {
          this.$toaster.error(err.message);
          this.$Progress.fail();
        });
    this.$Progress.start();
  }
};
</script>
<style lang="css" scoped>
.tourtheme {
  height: 180px;
  border-radius: 0px;
  margin: 5px;
  background-size: cover;
}
.hvr:hover {
  cursor: pointer;
  height: 200px;
  /* border : 3px solid; */
  /* border-color: black; */
}
.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.bckclr {
  -webkit-text-fill-color:cornflowerblue
}
.txt_dec:hover {
    text-decoration: none !important;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
</style>